import { DataAttributeDefinitions } from 'scrivito'

import { pisaActivityDataClass } from './Pisa/pisaActivityDataClass'

const attributes: DataAttributeDefinitions = {}

export const Activity = pisaActivityDataClass(attributes)
